import { __assign } from "tslib";
export var createWorkflowsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + "/recipes";
    var scenarioUrl = function (scenarioId) { return baseUrl + "/recipes/" + scenarioId; };
    var recipeUrl = function (recipeType) { return baseUrl + "/recipes/notification/" + recipeType + "/preview"; };
    return {
        getAll: function () {
            return http.get(apiUrl);
        },
        get: function (recipeId) {
            return http.get(scenarioUrl(recipeId));
        },
        addScenario: function (dto) {
            return http.post(apiUrl, __assign(__assign({}, dto), { disabled: false }));
        },
        deleteScenario: function (scenarioId) {
            return http.delete(scenarioUrl(scenarioId));
        },
        updateScenario: function (scenario) {
            return http.put(scenarioUrl(scenario.id), scenario);
        },
        enableScenario: function (scenarioId) {
            return http.put(scenarioUrl(scenarioId) + "/enable", {});
        },
        disableScenario: function (scenarioId) {
            return http.put(scenarioUrl(scenarioId) + "/disable", {});
        },
        getEmailTemplatePreview: function (_a) {
            var recipeType = _a.recipeType, locale = _a.locale;
            return http.post("" + recipeUrl(recipeType), { recipeType: recipeType, locale: locale });
        }
    };
};
//# sourceMappingURL=index.js.map